import { DESK } from "components/commons/MainLayout/constants";

const fullText = "A continuación veremos como está conformada la nomenclatura. Te recomendamos, para una mejor experiencia, desplazar tu cursor por los dígitos de la nomenclatura.";
const shortText = "A continuación veremos como está conformada la nomenclatura.";

export const getText = (size) => {
  if (size === DESK) return fullText;
  return shortText;
};
